import { DeductionActions } from '../constants';
import { QueryParams } from 'src/types/grid';

export interface GetDeductionsAction {
    type: typeof DeductionActions.FETCH_DEDUCTIONS;
    payload: QueryParams;
}

export function getDeductions(params: QueryParams): GetDeductionsAction {
    return {
        type: DeductionActions.FETCH_DEDUCTIONS,
        payload: params,
    };
}

export interface GetDeductionAction {
    type: typeof DeductionActions.FETCH_DEDUCTION;
    payload: {
        id: string | number;
    };
}

export function getDeduction(id: string | number): GetDeductionAction {
    return {
        type: DeductionActions.FETCH_DEDUCTION,
        payload: { id },
    };
}

export interface DeleteDeductionAction {
    type: typeof DeductionActions.DELETE_DEDUCTION;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteDeduction(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteDeductionAction {
    return {
        type: DeductionActions.DELETE_DEDUCTION,
        payload: { id, onSuccess, onError },
    };
}

export type Actions = GetDeductionsAction | GetDeductionAction | DeleteDeductionAction;
